import apple from '../../assets/images/apple-logo.png'
import androi from '../../assets/images/android-logo.png'
import fb from '../../assets/images/facebook-logo.png'
import zalo from '../../assets/images/zalo-logo.png'


import lotte from '../../assets/images/lotte.png'
import aribank from '../../assets/images/aribank.png'
import beta from '../../assets/images/beta.jpg'
import go from '../../assets/images/123go.png'
import ivb from '../../assets/images/IVB.png'
import laban from '../../assets/images/laban.png'
import payoo from '../../assets/images/payoo.jpg'
import touch from '../../assets/images/touch.png'
import vcb from '../../assets/images/VCB.png'
import vtb from '../../assets/images/VIETTINBANK.png'
import zalopay from '../../assets/images/zalopay_icon.png'
import startlight from '../../assets/images/STARLIGHT.png'
import bhd from '../../assets/images/bhd.png'
import galaxycine from '../../assets/images/galaxycine.png'
import dongdac from '../../assets/images/dongdacinema.png'
import dcine from '../../assets/images/dcine.png'
import mega from '../../assets/images/megags.png'
import cnx from '../../assets/images/cnx.jpg'
import cgv from '../../assets/images/cgv.png'
import cinestar from '../../assets/images/cinestar.png'
import zion from '../../assets/images/zion-logo.jpg'
import thongbao from '../../assets/images/thongbao.png'


export const imagesLogo = {
    apple: apple,
    androi: androi,
    fb: fb,
    zalo: zalo
}

export const loGoBig = {
    zion: zion,
    thongbao: thongbao,
}

export const supply = [
    { img: lotte },
    { img: aribank },
    { img: beta },
    { img: go },
    { img: ivb },
    { img: laban },
    { img: payoo },
    { img: touch },
    { img: vcb },
    { img: vtb },
    { img: zalopay },
    { img: startlight },
    { img: bhd },
    { img: galaxycine },
    { img: dongdac },
    { img: dcine },
    { img: mega },
    { img: cnx },
    { img: cgv },
    { img: cinestar },
]